import type { Action, ThunkAction } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';

import printMode from '~/redux/printMode';
import applicationPage from '~/application-review/redux/slice';
import employees from '~/dashboard/admin/employees/slice';
import journeyBuilder from '~/journey/redux/slice';
import { journeyEditorReducer } from '~/dashboard/views/journeys';
import sars from '~/dashboard/views/sars/form-view/redux/slice';
import session from '~/helpers/sessions/slice';
import webhookLogs from '~/dashboard/views/settings/webhooks/WebhookLogsView/redux/slice';
import workflowTestingSuite from '~/flow/TestingSuite/redux/slice';
import workflow from '~/flow/redux/slice';
import workflowEditor from '~/dashboard/views/workflows/store/redux/slice';
import investigations from '~/investigations/redux/slice';
import thresholdSimulator from '~/flow/thresholdSimulator/redux/slice';

const store = configureStore({
  reducer: {
    printMode,
    applicationPage,
    employees,
    journeyBuilder,
    journeyEditor: journeyEditorReducer,
    sars,
    session,
    webhookLogs,
    workflow,
    workflowEditor,
    workflowTestingSuite,
    investigations,
    thresholdSimulator,
  },
});

export type State = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; // used for Thunks
export type AppThunk<ReturnType = void> = ThunkAction<
ReturnType,
State,
unknown,
Action<string>
>;
export default store;
